export const spacing = '8px';
export const spacingLg = '16px';
